export const SINGLE_USER_LICENSE_CODE = 1004;
export const ADD_TO_BASKET_LOCALSTORAGE_KEY = "addToBasketOnLoginReturn";
// NB: The HTML `pattern` attribute is compiled with the RegExp `v` flag in modern
// browsers, which requires `( ) [ ] { } / - \ |` to be escaped inside character
// classes even when literal. An invalid pattern is silently ignored (treated as
// always-valid), so the hyphens below MUST stay escaped as `\-`.
export const EMAIL_REGEX = "^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$";
